import { api } from 'common';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';
import { Save } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import TextField from '@mui/material/TextField';
import { ISettingsType } from 'common/src/types';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";

const AppInformation = () => {
    const { editSettings } = api;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState<ISettingsType>();
    const settingsdata = useSelector(state => state.settingsdata);

    useEffect(() => {
        if (settingsdata.settings) {
            setData(settingsdata.settings);
        }
    }, [settingsdata.settings]);

    const handleTextChange = (e: any) => {
        setData({ ...data, [e.target.name]: e.target.value } as any);
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (data?.AllowCriticalEditsAdmin) {

            dispatch(editSettings(data));

        } else {
            alert(t('demo_mode'));
        }
    }



    return (
        data ?
            <form >
                <Grid item xs={12} sm={12}>
                    <div>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Typography component="h1" variant="h5">
                                    {t('app_info')}
                                </Typography>
                                <TextField
                                    required
                                    fullWidth
                                    id="appName"
                                    name="appName"
                                    margin="normal"
                                    variant="outlined"
                                    value={data.appName}
                                    label={t('AppName')}
                                    autoComplete="appName"
                                    onChange={handleTextChange}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    margin="normal"
                                    id="CompanyName"
                                    name="CompanyName"
                                    variant="outlined"
                                    label={t('CompanyName')}
                                    value={data.CompanyName}
                                    autoComplete="CompanyName"
                                    onChange={handleTextChange}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    id="CompanyAddress"
                                    name="CompanyAddress"
                                    label={t('COMPANY_ADDRESS')}
                                    value={data.CompanyAddress}
                                    onChange={handleTextChange}
                                    autoComplete="CompanyAddress"
                                />
                                <TextField
                                    required
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    id="CompanyWebsite"
                                    name="CompanyWebsite"
                                    onChange={handleTextChange}
                                    label={t('CompanyWebsite')}
                                    value={data.CompanyWebsite}
                                    autoComplete="CompanyWebsite"
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    id="contact_email"
                                    name="contact_email"
                                    label={t('contact_email')}
                                    value={data.contact_email}
                                    onChange={handleTextChange}
                                    autoComplete="contact_email"
                                />
                                <TextField
                                    required
                                    fullWidth
                                    margin="normal"
                                    id="CompanyPhone"
                                    variant="outlined"
                                    name="CompanyPhone"
                                    label={t('COMPANY_PHONE')}
                                    value={data.CompanyPhone}
                                    autoComplete="CompanyPhone"
                                    onChange={handleTextChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Typography component="h1" variant="h5" >
                                    {t('app_link')}
                                </Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin="normal"
                                    variant="outlined"
                                    id="CompanyTerms"
                                    label={t('terms')}
                                    name="CompanyTerms"
                                    value={data.CompanyTerms}
                                    autoComplete="CompanyTerms"
                                    onChange={handleTextChange}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    id="CompanyTermCondition"
                                    onChange={handleTextChange}
                                    label={t('term_condition')}
                                    name="CompanyTermCondition"
                                    value={data.CompanyTermCondition}
                                    autoComplete="CompanyTermCondition"
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    id="AppleStoreLink"
                                    name="AppleStoreLink"
                                    label={t('AppleStoreLink')}
                                    onChange={handleTextChange}
                                    value={data.AppleStoreLink}
                                    autoComplete="AppleStoreLink"
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    id="PlayStoreLink"
                                    name="PlayStoreLink"
                                    label={t('PlayStoreLink')}
                                    value={data.PlayStoreLink}
                                    onChange={handleTextChange}
                                    autoComplete="PlayStoreLink"
                                />
                                <Grid sx={{ mt: 5 }} container justifyContent={"center"}>
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <Button
                                            size="large"
                                            variant="contained"
                                            onClick={handleSubmit}
                                            startIcon={<Save />}
                                            sx={{
                                                py: 1.5,
                                                width: '100%',
                                                fontSize: '1rem',
                                                fontWeight: 600,
                                                boxShadow: 2,
                                                '&:hover': {
                                                    boxShadow: 4,
                                                    transform: 'translateY(-1px)',
                                                    transition: 'all 0.2s'
                                                },
                                                '&:disabled': {
                                                    opacity: 0.7
                                                }
                                            }}
                                        >
                                            {t('save')}
                                        </Button>

                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>

                    </div>
                </Grid>
            </form>
            :
            <CircularLoading />
    );

}

export default AppInformation;